/**
 * @desc 获取最新版的基线预测
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.SiteDimensionKeyDto>, options?: any) {
  return updateResponse(
    http(URL + `/wms/saleForecast/getNewest`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
